/* eslint-disable @angular-eslint/prefer-inject */
import { PackLineDataService } from '../infrastructure/pack-lines/pack-line.data.service';
import {
    PackLineCreate,
    PackLineDto,
    PackLineRead,
    PackLineSearchParams,
} from '../entities/pack-line.dto';
import { PackLineStore } from '../infrastructure/pack-lines/pack-line.store';
import { Injectable } from '@angular/core';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { PackLineMapper } from '../infrastructure/pack-lines/pack-line.mapper';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';

@Injectable()
export class PackLineFacade extends AbstractManageEntityFacade<
    PackLineDto,
    PackLineRead,
    PackLineCreate,
    PackLineSearchParams
> {
    nameField: keyof PackLineDto = 'packingListId';

    constructor(
        dataService: PackLineDataService,
        store: PackLineStore,
        mapper: PackLineMapper
    ) {
        super(dataService, null, store, mapper);
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField
    );

    protected override getParentId(dto: PackLineDto): string | undefined {
        return dto.packingListId;
    }

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof PackLineDto, string>> {
        return { packingListId: searchText };
    }
}
